import { render, staticRenderFns } from "./nurse.vue?vue&type=template&id=77539c07&scoped=true&"
import script from "./nurse.vue?vue&type=script&lang=js&"
export * from "./nurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77539c07",
  null
  
)

export default component.exports